import {
    Box,
    // MenuItem,
    Stack,
    IconButton,
    MenuItem,
} from '@mui/material';
import { common } from '@mui/material/colors';
import BaseNumberField from 'common/components/base-number-field';
// import BaseSlider from 'common/components/base-slider';
import BaseTextField from 'common/components/base-text-field';
import RequiredLabel from 'common/components/required-label';
import {
    // colors,
    styleInputNumber,
    // styleInputNumberMedium,
} from 'common/constants';
import { generateScaleMenuItems } from 'pages/admin/campaign-overview/constants';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { createStyleSheet } from 'utils/helpers';
import { IQuestionAnswer, IQuestionBaseProps } from 'types/campaign-design';
import QuestionDnD from './question-dnd';
import MinusIcon from '@mui/icons-material/Remove';
import PlusIcon from '@mui/icons-material/Add';
import { BaseSelectField } from 'common/components/base-select-field';

const QuestionSliderScale: React.FC<IQuestionBaseProps> = ({
    question,
    ...props
}) => {
    const {
        watch,
        control,
        setValue,
        // formState
    } = useFormContext();
    // const { isValid } = formState;
    const { remove, insert } = useFieldArray({
        control,
        name: `data.answers`,
    });
    // const [options, setOptions] = React.useState<
    //     {
    //         label: string;
    //         value: number;
    //     }[]
    // >([]);
    // const scale = watch('data.scale');
    const numberOfRows = watch(`data.numberOfRows`);
    const answers = watch('data.answers');
    // const gap = watch('data.gap');

    const removeAnswer = (fieldIndex: number) => {
        remove(fieldIndex);
        setValue('data.numberOfRows', numberOfRows ? numberOfRows - 1 : 0);
    };

    const insertAnswer = (fieldIndex: number) => {
        insert(fieldIndex + 1, {
            id: null,
            answer: `Tuỳ chọn ${numberOfRows + 1}`,
            score: 10,
        });
        setValue('data.numberOfRows', numberOfRows + 1);
    };
    //     const generateOptions = (scale: number, gap: number) => {
    //         const retOptions = [];
    //         for (let i = 0; i <= scale; i += gap) {
    //             if (gap === 1 && i % 2 === 0) {
    //                 retOptions.push({ label: ``, value: i });
    //             } else {
    //                 retOptions.push({ label: `${i}`, value: i });
    //             }
    //         }
    //         return retOptions;
    //     };
    // React.useEffect(() => {
    //     const generateOptions = (scale: number, gap: number) => {
    //         const retOptions = [];
    //         for (let i = 0; i <= scale; i += gap) {
    //             if (gap === 1 && i % 2 === 0) {
    //                 retOptions.push({ label: ``, value: i });
    //             } else {
    //                 retOptions.push({ label: `${i}`, value: i });
    //             }
    //         }
    //         return retOptions;
    //     };

    //     if (isValid && gap > 0) {
    //         const newOptions = generateOptions(Number(scale), Number(gap));
    //         setOptions(newOptions);
    //     }
    // }, [scale, gap, isValid]);

    return (
        <Box>
            <Stack p={'0px 35px 35px 35px'} gap={1}>
                <Box sx={{ display: 'flex', alignItems: 'start', gap: 8 }}>
                    <QuestionDnD {...props} question={question} />
                    {!question.answerFromOtherQuestionLogic?.id &&
                        answers?.length === 0 && (
                            <Box
                                display={'flex'}
                                alignItems={'center'}
                                width={'100%'}
                            >
                                <IconButton onClick={() => insertAnswer(0)}>
                                    <PlusIcon />
                                </IconButton>
                                <Box component={'span'}>Thêm đáp án</Box>
                            </Box>
                        )}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            width: '100%',
                        }}
                    >
                        {answers?.map(
                            (item: IQuestionAnswer, fieldIndex: number) => {
                                const answerValue = watch(
                                    `data.answers.${fieldIndex}.answer`
                                );
                                return (
                                    <Box
                                        key={`${item.id}_${fieldIndex}`}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            gap: 1,
                                        }}
                                    >
                                        <BaseTextField
                                            autoComplete="off"
                                            // fullWidth={false}
                                            name={`data.answers.${fieldIndex}.answer`}
                                            value={answerValue}
                                            size="small"
                                            placeholder="Nhập tùy chọn câu trả lời"
                                            sx={styles.answer}
                                            InputProps={{
                                                inputProps: {
                                                    maxLength: 255,
                                                },
                                            }}
                                        />
                                        {/* <Box
                                            sx={{
                                                borderRight: `2px solid ${colors.main}`,
                                                height: '44px',
                                            }}
                                        ></Box> */}
                                        {/* <BaseSlider
                                            name={`data.answers.${fieldIndex}.score`}
                                            defaultValue={scale}
                                            step={gap}
                                            marks={options}
                                            size="medium"
                                            max={scale}
                                            sx={{
                                                '& .MuiSlider-mark': {
                                                    display: 'block',
                                                    width: '2px',
                                                    height: '8px',
                                                    backgroundColor:
                                                        common.white,
                                                },
                                                '& .MuiSlider-rail': {
                                                    color: 'gray',
                                                },
                                            }}
                                        /> */}
                                        <Box
                                            display={'flex'}
                                            marginLeft={'30px'}
                                        >
                                            {answers.length > 1 && (
                                                <IconButton
                                                    onClick={() =>
                                                        removeAnswer(fieldIndex)
                                                    }
                                                >
                                                    <MinusIcon />
                                                </IconButton>
                                            )}
                                            <IconButton
                                                onClick={() =>
                                                    insertAnswer(fieldIndex)
                                                }
                                            >
                                                <PlusIcon />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                );
                            }
                        )}
                    </Box>
                </Box>
            </Stack>
            <Stack
                flexDirection={'row'}
                flexWrap={'wrap'}
                gap={4}
                p={'35px'}
                sx={{
                    borderTop: `2px dashed var(--color-primary)`,
                }}
            >
                <Stack flexDirection={'column'} gap={'20px'} display={'none'}>
                    <RequiredLabel
                        label="Số hàng"
                        required={false}
                        sx={{ fontSize: '16px', fontWeight: '500' }}
                    />
                    <BaseNumberField
                        sx={styleInputNumber}
                        size="small"
                        name={`data.numberOfRows`}
                        min={1}
                        max={20}
                        InputProps={{
                            readOnly: true,
                        }}
                        forceDisableMinus={
                            !!question.answerFromOtherQuestionLogic?.id
                        }
                        forceDisablePlus={
                            !!question.answerFromOtherQuestionLogic?.id
                        }
                        disabled={!!question.answerFromOtherQuestionLogic?.id}
                        showMinus={false}
                        showPlus={false}
                    />
                </Stack>
                <Stack flexDirection={'column'} gap={'20px'} maxWidth={'40%'}>
                    <RequiredLabel
                        label="Thang điểm"
                        required={false}
                        sx={{ fontSize: '16px', fontWeight: '500' }}
                    />
                    <BaseSelectField
                        name={`data.scale`}
                        size="small"
                        sx={{
                            '& .MuiInputBase-root': {
                                height: '24px',
                                backgroundColor: common.white,
                            },
                        }}
                    >
                        {generateScaleMenuItems(10, 100, 10).map((item) => (
                            <MenuItem key={item} value={item}>
                                {item}
                            </MenuItem>
                        ))}
                    </BaseSelectField>
                </Stack>
                <Stack flexDirection={'column'} gap={'20px'} maxWidth={'40%'}>
                    <RequiredLabel
                        label="Khoảng cách"
                        required={false}
                        sx={{ fontSize: '16px', fontWeight: '500' }}
                    />
                    <BaseSelectField
                        name={`data.gap`}
                        size="small"
                        sx={{
                            '& .MuiInputBase-root': {
                                height: '24px',
                                backgroundColor: common.white,
                            },
                        }}
                    >
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={5}>5</MenuItem>
                        <MenuItem value={10}>10</MenuItem>
                    </BaseSelectField>
                </Stack>
            </Stack>
        </Box>
    );
};

const styles = createStyleSheet({
    answer: {
        '& .MuiInputBase-root': {
            height: '44px',
            borderRadius: '50px',
            background: common.white,
        },
    },
});
export default QuestionSliderScale;
